import React,{useEffect} from "react";
import Header from "./Header";
import Footer from './Footer'
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
import Swal from 'sweetalert2'

function Home() {

    useEffect(()=>{
        test()
    },[])

    const test =()=>
    {
        Swal.fire({
            title: 'We are Under Development',
            text: '',
            icon: 'warning',
            confirmButtonText: 'Dismiss',
          }).then((result) => {
            if (result.value) {
             
            // For more information about handling dismissals please visit
            // https://sweetalert2.github.io/#handling-dismissals
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.fire(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              )
            }
          })
    }


  return (
    <>
    <Header/>
   
    <div class='container-fluid px-0 vh-50' style={{paddingTop:87}}>

    <Carousel infiniteLoop useKeyboardArrows autoPlay>
                <div>
                    <img src="/img/carindus.jpg" />
                </div>
                <div>
                    <img src="/img/carindus.jpg" />
                </div>
                <div>
                    <img src="/img/carindus.jpg" />
                </div>
            </Carousel>
      
      </div>
      <Footer/>
       </>
  );
}

export default Home;
